import { useModal } from '../../contexts/ModalContext'
import { useChallenge } from '../../hooks/challenge/useChallenge'
import { useChallengeId } from '../../hooks/challenge/useChallengeId'
import { useNotifications } from '../../hooks/notifications/useNotifications'
import PageHeader from '../../ui/layout/PageHeader'
import NotificationListPanelContainer from '../notifications/NotificationListPanelContainer'

export default function PageHeaderContainer() {
  const challengeId = useChallengeId()
  const { data: challenge } = useChallenge(challengeId)
  const { unreadCount } = useNotifications()
  const { openModal, closeModal } = useModal()

  function openNotifications() {
    const id = 'notifications'
    openModal(id, <NotificationListPanelContainer onClose={() => closeModal(id)} />)
  }

  return (
    <PageHeader
      unreadCount={unreadCount}
      challengeName={challenge?.name}
      challengeLogoUrl={challenge?.logoUrl}
      onOpenNotifications={openNotifications}
    />
  )
}
